import {
  SET_AGENTS_LIST,
  SET_AGENTS_LIST_PAGE,
  SET_AGENTS_LIST_PAGE_SIZE,
  SET_AGENTS_LIST_PAGE_SIZE_TOTAL,
  SET_AGENTS_LIST_QUERY,
  SET_AGENTS_LIST_SEARCHING,
  SET_VERIFY_QUERY,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'
const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  startDate: '',
  endDate: '',
  contactName: '',
  businessType: '',
})
const verifyQuery = () => ({
  id: '',
  verifyType: 0,
  remark: '',
  pactUrl: '',
  loginName: '',
  loginPassword: '',
  spreadUrl: '',
})
const state = {
  searching: false,
  initQuery: initQuery(),
  verifyQuery: verifyQuery(),
  agentsApplications: {
    list: [],
    // listCurrentPage: 1,
    listPageTotal: 0,
    // listPageSize: 50,
    query: initQuery(),
  },
}
const mutations = {
  [SET_AGENTS_LIST] (state, payload) {
    state.agentsApplications.list = payload
  },
  [SET_AGENTS_LIST_PAGE] (state, payload) {
    state.agentsApplications.query.pageNum = payload
  },
  [SET_AGENTS_LIST_PAGE_SIZE] (state, payload) {
    state.agentsApplications.query.pageSize = payload
  },
  [SET_AGENTS_LIST_PAGE_SIZE_TOTAL] (state, payload) {
    state.agentsApplications.listPageTotal = payload
  },
  [SET_AGENTS_LIST_QUERY] (state, payload) {
    state.agentsApplications.query = {
      ...state.agentsApplications.query,
      ...payload,
    }
  },
  [SET_AGENTS_LIST_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_VERIFY_QUERY] (state, payload) {
    state.verifyQuery = {
      ...state.verifyQuery,
      ...payload,
    }
  },
}
const actions = {
  // 获取代理商申请列表
  async setAgentsApplicationList ({commit, state}, payload) {
    try {
      let query = {}
      _.forIn(state.agentsApplications.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageNum: state.agentsApplications.query.pageNum,
        pageSize: state.agentsApplications.query.pageSize,
      }
      const {data: {items, total}} = await api.userApi.selectAgentApplyList(params)
      commit(SET_AGENTS_LIST_SEARCHING, false)
      commit(SET_AGENTS_LIST_PAGE_SIZE_TOTAL, total)
      commit(SET_AGENTS_LIST, items)
    } catch (error) {
      commit(SET_AGENTS_LIST, [])
      commit(SET_AGENTS_LIST_PAGE_SIZE_TOTAL, 0)
    }
  },
  async changeVerifyType({commit, state, dispatch}, payload) {
    try {
      commit(SET_VERIFY_QUERY, payload)
      let params = state.verifyQuery
      const {code} = await api.userApi.verifyAgent(params)
      if (code === 200) await dispatch('setAgentsApplicationList')
      return code
    } catch (error) {
      commit(SET_VERIFY_QUERY, verifyQuery)
    }
  },
  async uploadFile({commit, state, dispatch}, payload) {
    const {data} = await api.userApi.uploadFile(payload)
    return data
  },
  async changeAgentsListPage ({commit, state, dispatch}, payload) {
    commit(SET_AGENTS_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setAgentsApplicationList')
  },
  initAgentsApplicationList ({commit, dispatch}) {
    let query = initQuery()
    commit(SET_AGENTS_LIST_QUERY, query)
    dispatch('changeAgentsListPage', {currentPage: 1})
  },
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_AGENTS_LIST_SEARCHING, true)
    commit(SET_AGENTS_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeAgentsListPage', {currentPage: 1})
  },
  changeQuery ({commit}, payload) {
    commit(SET_AGENTS_LIST_QUERY, payload)
  },
  async addRemark ({commit, dispatch}, payload) {
    const {code, message, result} = await api.userApi.insertRemark(payload)
    dispatch('setAgentsApplicationList')
    return {code, message, result}
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
